var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgUser = function SvgUser(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 13.2 15",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.637 0c-2.2 0-4 1.8-4 4s1.8 4 4 4 4-1.8 4-4c-.1-2.2-1.9-4-4-4M11.5 10.489c-1-1.1-2.5-1.7-4-1.7H5.7c-1.5 0-3 .6-4 1.7-1.1 1.1-1.7 2.5-1.7 4.1 0 .2.2.4.4.4h12.3c.2 0 .4-.2.4-.4.1-1.6-.5-3-1.6-4.1",
    className: "user_svg__st0"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgUser);
export default ForwardRef;